import { cn } from '@/lib/utils';

interface LogoProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Visually hidden label override (defaults to "HumAIne"). */
  label?: string;
}

/* Wordmark-only logo — "HumAIne" in Manrope 800.
 * "AI" uses the brand gradient text utility.
 * The mark is pure text so it scales without assets and reads on both
 * light and dark backgrounds.
 */
export function Logo({ className, label = 'HumAIne', ...props }: LogoProps) {
  return (
    <span
      className={cn('inline-flex items-center', className)}
      aria-label={label}
      translate="no"
      {...props}
    >
      <span
        aria-hidden="true"
        className="font-display text-2xl font-extrabold leading-none tracking-tighter"
      >
        <span className="text-primary">Hum</span>
        <span className="text-gradient-text">AI</span>
        <span className="text-primary">ne</span>
      </span>
    </span>
  );
}
